const {
	fillWithDomElements,
	fillWithDomElementsAll,
	trackDownload,
	trackGtm4,
	disableStaticURL,
} = require('../../../../js/functions');

const CLASS_TITLE = 'ir-event-detail--title';
const CLASS_BLOCK = 'ir-event-detail--document-block';
const CLASS_DOWNLOAD = 'ir-event-detail--document';
const CLASS_QR_CODE = 'ir-event-detail--qr-code';
const CLASS_LOADING_OVERLAY = 'loading-overlay';

const CLASS_ACTIVE = 'active';

const SELECTOR_DOWNLOAD = '.ir-event-detail--document';
const SELECTOR_BLOCK_TITLE = '.ir-event-detail--block-title';

const selectors = {
	blocks: CLASS_BLOCK,
	widgetTitle: CLASS_TITLE,
	downloadButtons: CLASS_DOWNLOAD,
};
const selector = {
	qrCodeContainer: CLASS_QR_CODE,
	loadingOverlay: CLASS_LOADING_OVERLAY,
};
module.exports = {
	init() {
		fillWithDomElements(this, selector);
		fillWithDomElementsAll(this, selectors);
		this.initGtm();
		if (this.qrCodeContainer) this.initQrCode();
	},
	initGtm() {
		this.blocks.forEach(block => {
			const links = block.querySelectorAll(SELECTOR_DOWNLOAD);
			const blockTitle = block.querySelector(SELECTOR_BLOCK_TITLE);
			links.forEach(link => {
				if (link.hasAttribute('download')) {
					link.addEventListener('click', () => {
						trackGtm4({
							event: 'GA4_event_c_file_download',
							file_name: link.href.split('/').pop(),
							widget_name: 'V3-Investor Event Details',
							widget_title: this.widgetTitle[0].innerText,
							link_url: link.href,
							link_text: link.innerText,
							title: blockTitle.innerText,
						});
						trackDownload(link.innerText, link.href);
						disableStaticURL(link, 'download-disabled');
					});
				}
			});
		});
	},
	async initQrCode() {
		this.loadingOverlay.classList.add(CLASS_ACTIVE);
		const qrCode = await import(
			/* webpackChunkName: "qrcode" */ 'qrcode'
		).catch(error => {
			throw new Error(error);
		});
		const { qrCodeUrl, alt } = this.qrCodeContainer.dataset;
		const image = new Image();

		image.src = await qrCode.toDataURL(qrCodeUrl, {
			errorCorrectionLevel: 'M',
			width: 150,
			height: 150,
			margin: 0,
		});
		image.alt = alt;
		this.loadingOverlay.classList.remove(CLASS_ACTIVE);
		this.qrCodeContainer.appendChild(image);
	},
};
